import { useState, useEffect } from "react"
import classNames from "classnames"

import { formatAs } from "web/services/format"

export default function EditInPlace({
  value: initialValue,
  onChange,
  format,
  validator,
  transformer,
  autoSelect = false,
  placeholder = null,
  testId = "",
  readOnly = false,
  title = "",
}) {
  const [value, setValue] = useState(initialValue)
  const [mode, setMode] = useState("view")

  const hasValidator = typeof validator === "function"
  const hasTransformer = typeof transformer === "function"

  function handleInputChange(e) {
    const newValue = e.target.value

    if (!hasValidator || validator(newValue)) {
      setValue(newValue)
    }
  }

  function handleBlur() {
    setMode("view")
    if (value !== initialValue) {
      if (hasTransformer) {
        setValue(transformer(value))
      }
      onChange(hasTransformer ? transformer(value) : value)
    }
  }

  function cancel() {
    setValue(initialValue)
    setMode("view")
  }

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const hasValue = value !== null && value !== undefined && value !== ""

  if (mode === "view") {
    return (
      <div className="cursor-text overflow-hidden" title={title}>
        <div
          data-testid={`div-edit-in-place-${testId}`}
          className={classNames(
            "box-border max-w-full truncate border-b border-transparent",
            {
              "mutable hover:border-b hover:border-dashed hover:border-neutral-1":
                !readOnly,
              "h-6 text-neutral-8": !hasValue,
            }
          )}
          onClick={(e) => {
            e.stopPropagation()
            if (!readOnly) setMode("edit")
          }}
        >
          {hasValue && format ? formatAs(format, { value }) : value}
          {!hasValue && placeholder}
        </div>
      </div>
    )
  }

  return (
    <input
      type="text"
      data-testid={`input-edit-in-place-${testId}`}
      autoFocus={true}
      placeholder={placeholder}
      className="-my-1.5 box-border w-full border-b border-none border-transparent p-1 outline-none focus:outline-none"
      value={value}
      onClick={(e) => {
        e.stopPropagation()
      }}
      onChange={handleInputChange}
      onBlur={handleBlur}
      onKeyUp={(e) => {
        if (e.which === 13) e.target.blur()
        if (e.which === 27) cancel()
      }}
      onFocus={(e) => {
        if (autoSelect) e.target.select()
      }}
    />
  )
}
